// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Gp1Z","consentsList":"PatientConsents_consentsList__23X8f","consentsListEmpty":"PatientConsents_consentsListEmpty__2WXI1"};